export default __webpack_public_path__ + "static/media/express.04e4743f.png";